export default __webpack_public_path__ + "static/media/matthew.308e21b7.png";